// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ph-0";